export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50 to-background-100/40"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium mb-5">
                <i className="ri-fire-line"></i>
                <span>全网热门影视</span>
              </div>

              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
                片多多影视
                <span className="block text-primary-600 mt-1">高清免费在线观影平台</span>
              </h1>

              <p className="mt-3 font-heading text-base md:text-lg text-accent-600 font-medium">
                不卡顿 · 超清画质 · 完全免费
              </p>

              <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                片多多影视汇聚全网热门电影、电视剧、综艺、动漫等海量高清影视资源，每日同步更新最新内容。无论您喜欢动作大片、温情剧集还是热门综艺，片多多免费观看不卡顿，超清画质在线看，打造属于您的私人高清影院，全网热门影视一网打尽，无需付费畅享流畅观影体验。
              </p>

              <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">20000+</div>
                  <div className="text-xs text-foreground-500 mt-1">海量影视资源</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                  <div className="text-xs text-foreground-500 mt-1">同步最新内容</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">1080P+</div>
                  <div className="text-xs text-foreground-500 mt-1">超清画质体验</div>
                </div>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#ranking"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-flashlight-line"></i>
                  立即观影
                </a>
                <a
                  href="#about"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-300/60"
                >
                  <i className="ri-information-line"></i>
                  了解更多
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md lg:max-w-lg">
                <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20golden%20and%20amber%20tones%2C%20flowing%20film%20strips%20and%20soft%20light%20rays%20forming%20elegant%20patterns%2C%20modern%20minimalist%20aesthetic%20with%20dark%20background%20and%20glowing%20highlights%2C%20sophisticated%20entertainment%20atmosphere%2C%20artistic%20movie%20theme%20visual%2C%203D%20render%20style%20with%20smooth%20gradients%20and%20organic%20shapes%2C%20luxurious%20textures&width=900&height=1125&seq=hero-main-visual&orientation=portrait"
                    alt="片多多影视高清免费在线观影平台主视觉"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-3 -right-3 w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-primary-500/90 flex flex-col items-center justify-center backdrop-blur-sm">
                  <i className="ri-play-circle-fill text-background-50 text-2xl md:text-3xl"></i>
                  <span className="text-background-50 text-xs md:text-sm font-bold mt-1 whitespace-nowrap">免费看</span>
                </div>
                <div className="absolute -top-3 -left-3 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-accent-500/90 flex flex-col items-center justify-center backdrop-blur-sm">
                  <i className="ri-4k-fill text-background-50 text-xl md:text-2xl"></i>
                  <span className="text-background-50 text-xs font-bold mt-1 whitespace-nowrap">超清</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}